export const drawer = {
  defaultProps: {
    size: 300,
    overlay: true,
    placement: "left",
    overlayProps: {
      className: "!duration-0",
    },
    dismiss: undefined,
    onClose: undefined,
    transition: {
      duration: 0,
    },
  },
  styles: {
    base: {
      drawer: {
        position: "fixed",
        zIndex: "z-[var(--drawer-zIndex)]",
        pointerEvents: "pointer-events-auto",
        backgroundColor: "bg-white",
        boxSizing: "box-border",
        width: "w-full",
        boxShadow: "shadow-2xl shadow-blue-gray-900/10",
      },
      overlay: {
        position: "absolute",
        inset: "inset-0",
        width: "w-full",
        height: "h-full",
        pointerEvents: "pointer-events-auto",
        zIndex: "z-[var(--drawer-overlay-zIndex)]",
        backgroundColor: "bg-[#000] dark:bg-[#7D7D7D66]",
        backgroundOpacity: "bg-opacity-30",
        backdropBlur: "backdrop-blur-[12px]",
      },
    },
  },
};
